export const parseCcEmails = cc => {
  return cc
    .split(',')
    .map(email => email.trim())
    .filter(email => email)
}
